import React from 'react'

import { Hierarchy, SubVariant } from '@flowwai-frontend/design-system'
import { useAppTheme } from '@flowwai-frontend/bps-officer-web/style-guide'
import { useCustomT } from '@flowwai-frontend/shared/common-components'
import {
   AlertCircleIcon,
   RefreshCCW01Icon
} from '@flowwai-frontend/design-system/icons'

import { actionCRMToast } from '../utils/ToastUtil'
import { commonTheme } from '../themes'

interface UseFailureToastWithRefreshType {
   showFailureToastWithRefresh: (
      title: string,
      description: string,
      onClickRefresh: () => void
   ) => void
}

export const useFailureToastWithRefresh = (): UseFailureToastWithRefreshType => {
   const { toastUtils } = commonTheme

   const t = useCustomT('common:common')
   const renderToastLeftIcon = (color: string): React.ReactElement => (
      <AlertCircleIcon height={20} width={20} fill={color} />
   )

   const showFailureToastWithRefresh = (
      title: string,
      description: string,
      onClickRefresh: () => void
   ): void => {
      actionCRMToast(
         title,
         description,
         'FAILURE',
         {
            label: t('refresh'),
            value: t('refresh'),
            onClickAction: onClickRefresh,
            hierarchy: Hierarchy.Secondary,
            subVariant: SubVariant.GrayOutline,
            renderLeftIcon: () => (
               <RefreshCCW01Icon
                  fill={toastUtils.refreshButtonRetryIconColor}
               />
            )
         },
         renderToastLeftIcon
      )
   }

   return { showFailureToastWithRefresh }
}
